import React, {Component} from 'react'
import PropTypes from 'prop-types'

import AbbonamentoLogo from '../../../assets/logo-abbonamento.png'
import DownloadLogo from '../../../assets/download.png'
import {NavLink} from 'react-router-dom'
import moment from 'moment'
import UserInfoBox from '../UserInfoBox/UserInfoBox'
import Threesome from "../../../assets/triangolo.png";

const TextUser = (props) => <div className={props.bold ? "text-bold-user" : "text-regular-user"}>{props.children}</div>

export default class UserAreaParkTickets extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (<div className="row">
      <div className="col-md-7">
        <div className="panel panel-default panel-border-login">
          <h2 className="login-title">ABBONAMENTI</h2>
          <div className="panel-body">
            <div className="col-md-3"><img className="user-admin-logo" src={AbbonamentoLogo} /></div>
            <div className="col-md-9">
              <div className="user-card-btn-1">
                <div className="row" style={{display: 'flex'}}>
                  <div className="col-md-10 text-left col-personalized-user">
                    <strong>ACQUISTA ABBONAMENTO </strong>
                  </div>
                  {/* <a className="user-card-btn3" href="javascript:void(0);"><strong>+</strong></a> */}
                  <NavLink className={'user-card-btn3'} to="/user-area/waiting-lists"><strong>+</strong></NavLink>
                </div>
              </div>
              {this.props.user.parkTickets && this.props.user.parkTickets.map(item => <div key={item.id}>
                <div className="user-card">
                  <div className="user-card-head-a">
                    <div className="user-card-title">
                      <span>ABBONAMENTO: <strong>{item.ParkTicketType.printLabel && 'AGEVOLATO ' + item.ParkTicketType.printLabel} {!item.ParkTicketType.printLabel && 'STANDARD'}</strong></span>
                    </div>
                  </div>
                  <div className="user-card-body">
                    <div className="row">
                      <div style={{padding: 0, marginTop: -3, marginBottom: 3}} className="col-md-2">
                        <span>N. <strong>{item.id}</strong></span>
                      </div>
                      <div style={{padding: 0, marginTop: -3, marginBottom: 3}} className="col-md-10">
                        {item.ParkTicketType.MarkType && <span style={{marginLeft: 15}}>
                                                            ZON{item.ParkTicketType.MarkType.Areas.length > 1 ? 'E' : 'A'}  <strong>{item.ParkTicketType.MarkType.Areas.map(item => item.code + ' ')}</strong></span>}
                      </div>
                      <div style={{padding: 0, marginTop: -3, marginBottom: 3}} className="col-md-10">
                        {!item.ParkTicketType.MarkType && <span style={{marginLeft: 15}}>
                                                            ZONE <strong>S1 S2</strong></span>}
                      </div>
                      <div style={{padding: 0}} className="col-md-12">
                        {item.markId && <span>NUM. CONTRASSEGNO: <strong>{item.markId}</strong></span>}
                      </div>
                      <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-10">
                        {item.Vehicle && <span>TARGA: <strong>{item.Vehicle.plate_number}</strong></span>}
                      </div>
                    </div>
                  </div>
                  <div className="border-div" />
                  <div className="user-card-footer">
                    <div className="row">
                      <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                        <span>EMESSO IL: <strong>{moment(item.issudeDate).format('L')}</strong></span>
                      </div>
                      <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                        <span>VALIDO DAL <strong>{moment(item.startDate).format('L')}</strong> AL <strong>{moment(item.endDate).format('L')}</strong></span>
                      </div>
                      <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                        <div className="col-md-6 col-btn-display">
                                <a onClick={() => this.props.onDownloadParkTicket(item)} className="btn-download-user">
                            <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1}} src={DownloadLogo}>{}</img> ABBONAMENTO</a>
                              </div>
                        <div className="col-md-6 col-btn-display">
                                {item.receiptId && <a onClick={() => this.props.onReceiptDownload(item.id)} className="btn-download-user">
                            <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1}} src={DownloadLogo}>{}</img> RICEVUTA</a>}
                              </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4 col-md-offset-1 col-information-user hidden-xs hidden-sm">
        <div className="information-container">
          <div style={{marginLeft: 30}}>
            <div style={{marginTop: 15, marginBottom: 10}}>
              <TextUser bold>ABBONAMENTI</TextUser>
              <TextUser>
                In questa sezione puoi vedere gli abbonamenti che hai acquistato.<br />
                <span style={{color: '#eb232f'}}><strong>Attenzione! </strong>Al momento tutte le funzionalità riguardanti gli abbonamenti sono disabilitate e non cliccabili.</span>
              </TextUser>
            </div>
          </div>
        </div>
      </div>

    </div>)
  }
}

UserAreaParkTickets.defaultProps = {}

UserAreaParkTickets.propTypes = {}



// WEBPACK FOOTER //
// ./src/containers/UserArea/ParkTicket/UserAreaParkTickets.js